import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-form-button',
  templateUrl: './form-button.component.html',
  styleUrls: ['./form-button.component.scss']
})
export class EclsButtonComponent implements OnInit {

  @Input() title: string = '';
  @Input() size: string = 'md';
  @Input() rounded: boolean = false;
  @Input() color: string = 'primary';
  @Input() disabled: boolean = false;
  @Input() outline: boolean = false;

  @Output() clicked = new EventEmitter();

  /**
   * 
   */
  constructor() { }

  onClick() {
   this.clicked.emit();
  }

  /**
   * 
   */
  ngOnInit(): void {
  }

}
